
{
  "familyId": "STU-NOTITIES",
  "questions": [
    {
      "id": "STU-NOTITIES-001",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "multiple_choice",
      "question": "Wat is het belangrijkste doel van notities maken tijdens een les?",
      "options": ["De belangrijkste informatie onthouden", "Alles letterlijk opschrijven", "Mooie zinnen maken", "De leraar laten zien dat je oplet"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Doel van notities", "content": "Notities helpen je de belangrijkste informatie te onthouden. Je schrijft niet alles op, maar alleen de kernpunten.", "icon": "lightbulb"}}],
      "conceptId": "notities_doel",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Het belangrijkste doel van notities is de belangrijkste informatie onthouden. Door kernpunten op te schrijven, verwerk je de stof beter en kun je later terugkijken.",
        "solutionSteps": ["Notities = hulpmiddel om te onthouden", "Schrijf kernpunten op, niet alles", "Later kun je je notities gebruiken om te leren"],
        "distractorExplanations": {
          "0": "Goed! Notities helpen je de belangrijkste informatie te onthouden.",
          "1": "Je dacht waarschijnlijk dat je alles moet opschrijven. Maar dan luister je niet meer goed. Onthoud: schrijf alleen de kernpunten op.",
          "2": "Je dacht waarschijnlijk dat notities mooi moeten zijn. Maar notities zijn voor jezelf — ze hoeven niet perfect te zijn. Onthoud: duidelijk is belangrijker dan mooi.",
          "3": "Je dacht waarschijnlijk dat het om opletten gaat. Opletten is belangrijk, maar het echte doel is informatie onthouden en verwerken."
        }
      }
    },
    {
      "id": "STU-NOTITIES-002",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "multiple_choice",
      "question": "Welke techniek is het handigst bij het maken van notities?",
      "options": ["Steekwoorden en afkortingen gebruiken", "Hele zinnen opschrijven", "Alleen de titel opschrijven", "Alles in één lange zin schrijven"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Notitietechniek", "content": "Gebruik steekwoorden en afkortingen. Zo schrijf je snel en houd je tijd over om te luisteren. Voorbeeld: 'fotosynthese = plant maakt voedsel m.b.v. zonlicht'.", "icon": "lightbulb"}}],
      "conceptId": "notities_techniek",
      "variantIndex": 2,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Steekwoorden en afkortingen zijn het handigst. Zo schrijf je snel en houd je tijd over om te luisteren. Hele zinnen kosten te veel tijd.",
        "solutionSteps": ["Gebruik steekwoorden (kernwoorden)", "Gebruik afkortingen (bijv. = bv., bijvoorbeeld = bvb.)", "Schrijf snel, luister goed"],
        "distractorExplanations": {
          "0": "Goed! Steekwoorden en afkortingen zijn snel en effectief.",
          "1": "Je dacht waarschijnlijk dat hele zinnen beter zijn. Maar dan ben je zo druk met schrijven dat je niet meer luistert. Onthoud: steekwoorden zijn sneller en net zo nuttig.",
          "2": "Je dacht waarschijnlijk dat de titel genoeg is. Maar de titel vertelt niet wat er in de les is besproken. Onthoud: noteer ook de kernpunten.",
          "3": "Je dacht waarschijnlijk dat één lange zin handig is. Maar dat is moeilijk terug te lezen. Onthoud: gebruik korte punten of opsommingen."
        }
      }
    },
    {
      "id": "STU-NOTITIES-003",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "multiple_choice",
      "question": "Je maakt notities bij een les over vulkanen. Welke notitie is het meest nuttig?",
      "options": [
        "Vulkaan = opening in aardkorst, magma komt naar buiten → lava",
        "De leraar vertelt over vulkanen en dat is heel interessant",
        "Vulkanen",
        "Er zijn vulkanen op aarde en die kunnen uitbarsten en dat is gevaarlijk"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Goede notitie", "content": "Een goede notitie bevat kernwoorden en korte uitleg. Gebruik pijltjes (→) en is-tekens (=) om verbanden te laten zien.", "icon": "lightbulb"}}],
      "conceptId": "notities_kwaliteit",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De eerste notitie is het meest nuttig: kort, met kernwoorden, en met een pijltje dat het verband laat zien (magma → lava). De andere notities zijn te vaag, te kort, of te lang.",
        "solutionSteps": ["Goede notitie: kernwoorden + korte uitleg", "Gebruik symbolen: = (is), → (leidt tot), + (en)", "Optie A doet dit het best ✓"],
        "distractorExplanations": {
          "0": "Goed! Kort, met kernwoorden en een duidelijk verband (→).",
          "1": "Je dacht waarschijnlijk dat je mening erbij hoort. Maar notities gaan over feiten, niet over wat je ervan vindt. Onthoud: schrijf op wat je leert, niet wat je voelt.",
          "2": "Je dacht waarschijnlijk dat één woord genoeg is. Maar 'vulkanen' vertelt je later niets over wat je hebt geleerd. Onthoud: voeg altijd kernpunten toe.",
          "3": "Je dacht waarschijnlijk dat een hele zin beter is. Maar deze zin is te lang en bevat geen structuur. Onthoud: gebruik steekwoorden en symbolen."
        }
      }
    },
    {
      "id": "STU-NOTITIES-004",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "multiple_choice",
      "question": "Wanneer is het handig om je notities na te kijken en aan te vullen?",
      "options": ["Zo snel mogelijk na de les", "Pas vlak voor de toets", "Nooit, notities zijn af als je ze maakt", "Alleen als de leraar het vraagt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Notities nakijken", "content": "Kijk je notities zo snel mogelijk na de les na. Dan weet je nog wat er is besproken en kun je ontbrekende informatie aanvullen.", "icon": "lightbulb"}}],
      "conceptId": "notities_nakijken",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Kijk je notities zo snel mogelijk na de les na. Dan herinner je je nog wat er is besproken en kun je onduidelijke punten aanvullen. Hoe langer je wacht, hoe meer je vergeet.",
        "solutionSteps": ["Na de les: notities nakijken", "Onduidelijke punten aanvullen", "Hoe sneller, hoe beter (je vergeet snel!)"],
        "distractorExplanations": {
          "0": "Goed! Zo snel mogelijk nakijken zorgt dat je niets vergeet.",
          "1": "Je dacht waarschijnlijk dat je kunt wachten tot de toets. Maar dan ben je al veel vergeten en zijn je notities moeilijk te begrijpen. Onthoud: hoe sneller je nakijkt, hoe beter.",
          "2": "Je dacht waarschijnlijk dat notities meteen af zijn. Maar tijdens de les schrijf je snel en mis je soms dingen. Onthoud: nakijken en aanvullen maakt je notities compleet.",
          "3": "Je dacht waarschijnlijk dat het alleen hoeft als de leraar het vraagt. Maar notities zijn voor jezelf — jij hebt er het meeste aan. Onthoud: neem zelf de verantwoordelijkheid."
        }
      }
    },
    {
      "id": "STU-NOTITIES-005",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "matching",
      "question": "Koppel elke notitietechniek aan de juiste beschrijving.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Steekwoorden", "Afkortingen", "Pijltjes (→)", "Opsommingstekens"],
        "rightItems": ["Geven verbanden aan", "Maken een lijst overzichtelijk", "Kernwoorden uit de les", "Maken schrijven sneller"],
        "correctMatches": {"0": 2, "1": 3, "2": 0, "3": 1}
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Notitietechnieken", "content": "Steekwoorden = kernwoorden. Afkortingen = sneller schrijven. Pijltjes = verbanden. Opsommingstekens = overzicht.", "icon": "lightbulb"}}],
      "conceptId": "notities_technieken_koppelen",
      "variantIndex": 5,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Steekwoorden zijn kernwoorden uit de les. Afkortingen maken schrijven sneller. Pijltjes geven verbanden aan (oorzaak → gevolg). Opsommingstekens maken een lijst overzichtelijk.",
        "solutionSteps": ["Steekwoorden → kernwoorden uit de les", "Afkortingen → maken schrijven sneller", "Pijltjes (→) → geven verbanden aan", "Opsommingstekens → maken een lijst overzichtelijk"]
      }
    }
  ]
}
